import { useEffect, useState } from 'react';

// Resize the whole shell when the keyboard opens, so the composer and scroll
// area share one height instead of translating the composer over the content.
export default function useMobileViewport() {
  const [viewport, setViewport] = useState({ height: undefined, keyboardOpen: false });

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    let frame;
    let restingHeight = vv.height;
    const update = () => {
      const mobile = window.matchMedia('(max-width: 1023px)').matches;
      const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
      if (!editing) restingHeight = vv.height;
      // Pinch zoom must retain the browser's own panning/zoom behavior.
      const useViewport = mobile && vv.scale === 1;
      setViewport({
        height: useViewport ? vv.height : undefined,
        keyboardOpen: useViewport && editing && Math.max(window.innerHeight, restingHeight) - vv.height > 120,
      });
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    update();
    vv.addEventListener('resize', schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    return () => {
      cancelAnimationFrame(frame);
      vv.removeEventListener('resize', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
    };
  }, []);

  return viewport;
}
